import React, { useState, useRef, useEffect } from "react"
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from 'react-redux'

import { getFlags, getDepartments, getTeams } from '../../routes/UserAction';

import { domain, reduceText } from '../../data/dummyData';

import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';

import OwlCarousel from "react-owl-carousel3";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "./Carousel.css";

export default function About() {
    const dispatch = useDispatch();
    const {
        loading,
        user,
        error,
        success,
        successMessage,
    } = useSelector((state) => state.user || {});
    const userData = user;

    const [flags, setFlags] = useState([]);
    const [teams, setTeams] = useState({});
    const [departments, setDepartments] = useState([]);

    const fetchTeams = () => {
        dispatch(getTeams())
        .then(response =>{
            let resData = response?.payload?.data;
            // const editableData = resData?.map(o => ({ ...o }));
            setTeams(resData);
        })
        .catch((error) => {
            console.log(error)
        })
    }

    const fetchFlags = () => {
        dispatch(getFlags())
        .then(response =>{
            let resData = response?.payload?.data;
            const editableData = resData?.map(o => ({ ...o }));
            setFlags(editableData);
        })
        .catch((error) => {
            console.log(error)
        })
    }

    const fetchDepartments = () => {
        dispatch(getDepartments())
        .then(response =>{
            let resData = response?.payload?.data;
            const editableData = resData?.map(o => ({ ...o }));
            setDepartments(editableData);
        })
        .catch((error) => {
            console.log(error)
        })
    }

    useEffect(() => {
        fetchFlags();
        fetchDepartments();
        fetchTeams();
    }, [])

    const options3 = {
        loop: true,
        margin: 10,
        nav: false,
        dots: true,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        // items: 3,
        responsive: {
            0: {
                items: 1, // 1 item for small screens (mobile)
            },
            600: {
                items: 2, // 2 items for medium screens (tablets)
            },
            1000: {
                items: 3, // 3 items for larger screens (desktops)
            }
        }
    };


    return (
        // loading ? (
        //   <div className="loader-container">
        //       <div className="spinner"></div>
        //       {/* <h6 style={{color: 'white', textAlign:'center'}}>loading please wait...</h6> */}
        //   </div>
        // ) :
        <>
        <Header page={'about'}/>

            
        {/* <!-- About Start --> */}
        <div className="container-fluid about pt-5" style={{zIndex: 1}}>
            <div className="container pt-5">
                <div className="row g-5">
                    <div className="col-xl-6 wow fadeInLeft" data-wow-delay="0.2s">
                        <div className="about-content h-100">
                            <h4 className="" style={{color: 'gold'}}>About MJ-EmyLab</h4>
                            <h1 className="display-4 text-white mb-4">{flags?.filter(el => (el.name== 'emy_about1' && el.type == 1))?.length ? flags.filter(el => (el.name== 'emy_about1' && el.type == 1))[0].value : <></>}</h1>
                            <p className="mb-4 text-white">{flags?.filter(el => (el.name== 'emy_about2' && el.type == 1))?.length ? flags.filter(el => (el.name== 'emy_about2' && el.type == 1))[0].value : <></>}</p>
                            <div className="tab-class pb-4">
                                <ul className="nav d-flex mb-2">
                                    <li className="nav-item mb-3">
                                        <a className="d-flex py-2 active" data-bs-toggle="pill" href="#tab-1">
                                            <span style={{width: '150px'}}>Our Mission</span>
                                        </a>
                                    </li>
                                    <li className="nav-item mb-3">
                                        <a className="d-flex py-2 mx-3" data-bs-toggle="pill" href="#tab-2">
                                            <span style={{width: '150px'}}>Our Vision</span>
                                        </a>
                                    </li>
                                    <li className="nav-item mb-3">
                                        <a className="d-flex py-2" data-bs-toggle="pill" href="#tab-3">
                                            <span style={{width: '150px'}}>Our Goal</span>
                                        </a>
                                    </li>
                                </ul>
                                <div className="tab-content">
                                    <div id="tab-1" className="tab-pane fade show p-0 active">
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="d-flex align-items-center border-top border-bottom py-4">
                                                    <span className="fas fa-rocket text-white fa-4x me-4"></span>
                                                    <p className="mb-0 text-white">
                                                        {flags?.filter(el => (el.name== 'emy_mission' && el.type == 1))?.length ? flags.filter(el => (el.name== 'emy_mission' && el.type == 1))[0].value : <></>}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="tab-2" className="tab-pane fade show p-0">
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="d-flex align-items-center border-top border-bottom py-4">
                                                    <span className="fas fa-rocket text-white fa-4x me-4"></span>
                                                    <p className="mb-0 text-white">
                                                        {flags?.filter(el => (el.name== 'emy_vision' && el.type == 1))?.length ? flags.filter(el => (el.name== 'emy_vision' && el.type == 1))[0].value : <></>}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="tab-3" className="tab-pane fade show p-0">
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="d-flex align-items-center border-top border-bottom py-4">
                                                    <span className="fas fa-rocket text-white fa-4x me-4"></span>
                                                    <p className="mb-0 text-white">
                                                        {flags?.filter(el => (el.name== 'emy_goal' && el.type == 1))?.length ? flags.filter(el => (el.name== 'emy_goal' && el.type == 1))[0].value : <></>}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row g-4 align-items-center">
                                <div className="col-sm-6">
                                    <Link to={'/contact'} className="btn btn-primary py-3 px-5"><span>For Enquiries</span></Link>
                                </div>
                                <div className="col-sm-6">
                                    <div className="d-flex flex-shrink-0 ps-4">
                                        <a href="#" className="btn btn-light btn-lg-square position-relative wow tada" data-wow-delay=".9s">
                                            <i className="fa fa-phone-alt fa-2x"></i>
                                            <div className="position-absolute" style={{top: '5px', right: '5px'}}>
                                                <span><i className="fa fa-comment-dots text-dark"></i></span>
                                            </div>
                                        </a>
                                        <div className="d-flex flex-column ms-3">
                                            {/* <span>Contact</span> */}
                                            <a
                                                href={`tel:${flags?.find(el => el.name === 'emy_phone' && el.type === 1)?.value || '(+233) 559 148 214'}`}
                                            >
                                                <span className="text-white">
                                                 {flags?.find(el => el.name === 'emy_phone' && el.type === 1)?.value || '(+233) 559 148 214'}
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6 wow fadeInUp" data-wow-delay="0.2s">
                        <div className="about-img h-100">
                            <div className="about-img-inner d-flex h-100">
                                <img src={flags?.filter(el => (el.name== 'emy_logo' && el.type == 1))?.length ? domain+flags.filter(el => (el.name== 'emy_logo' && el.type == 1))[0].value : "./assets/img/emy.png"} className="img-fluid w-100" style={{objectFit: 'contain'}} alt=""/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {/* <!-- About End --> */}


        {/* <!-- Team Start --> */}
        <div className="container-fluid blog py-5">
            <div className="container py-5">
                <div className="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s" style={{maxWidth: '800px'}}>
                    {/* <h4 className="text-primary">  Our Blogs</h4> */}
                    <h4 className="" style={{color: 'gold'}}> EmyTeam </h4>
                    <h1 className="display-4 mb-4">Our National Team</h1>
                </div>

                <OwlCarousel
                    className="blog-carousel owl-carousel"
                    {...options3}
                >
                {/* <div className="blog-carousel owl-carousel"> */}
                    {teams?.members?.length ? teams?.members?.map((row) => (
                        <div className="blog-item wow fadeInUp" data-wow-delay="0.2s">
                            <div className="blog-img p-4 pb-0">
                                <a href="#">
                                    <img src={row.image? domain+row.image:"./assets/img/soft.png"} className="img-fluid w-100" alt=""/>
                                </a>
                            </div>
                            <div className="blog-content p-4">
                                <div className="blog-comment d-flex justify-content-center py-2 px-3 mb-4">
                                    
                                    <div className="small text-primary"><span className="fa fa-calendar text-primary me-2"></span> {row?.msg? row?.msg: ''}</div>
                                </div>
                                <a href="#" className="h4 d-inline-block mb-3">{row?.name? row?.name: ''}</a>
                                <p className="mb-3">{row?.about? reduceText(row?.about, 200, '...'): ''}</p>
                                <Link to={row.uuid? `/chat?id=${row.uuid}&&cat=member`:'/'} className="btn btn-dark py-2 px-4 ms-2"> <span className="me-2">Contact</span>  <i className="fa fa-arrow-right"></i></Link>
                            </div>
                        </div>
                    )) : <></>}
                    
                {/* </div> */}
                </OwlCarousel>
            </div>
        </div>
        {/* <!-- Team End --> */}


        {/* <!-- Departments Start --> */}
        <div className="container-fluid team py-5" style={{ 
            position: 'relative',
            overflow: 'hidden',
            background: "linear-gradient(rgba(255, 245, 225, 0.9), rgba(132, 199, 137, 0.9)), url('./assets/img/afro.png')",
            backgroundPosition: 'center center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
        }}>
            <div className="container py-5">
                <div className="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s" style={{maxWidth: '800px'}}>
                    <h4 className="" style={{color: 'gold'}}>EmyLabs</h4>
                    <h1 className="display-4 mb-4">Our departments</h1>
                    {/* <p className="mb-0">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tenetur adipisci facilis cupiditate recusandae aperiam temporibus corporis itaque quis facere, numquam, ad culpa deserunt sint dolorem autem obcaecati, ipsam mollitia hic.
                    </p> */}
                </div>
                <div className="row gy-5 gy-lg-4 gx-4">
                    {departments?.length? departments.map((row) => (
                        <div key={row.id} className="col-md-6 col-lg-3 wow fadeInUp" data-wow-delay="0.2s">
                            <div className="team-item">
                                <div className="team-img">
                                    <img src={row.image? domain+row.image:"./assets/img/soft.png"} className="img-fluid w-100" alt="Image"/>
                                    <div className="team-icon">
                                        <a href="#" className="btn btn-primary btn-sm-square"><i className="fab fa-facebook-f"></i></a>
                                        <a href="#" className="btn btn-primary btn-sm-square"><i className="fab fa-twitter"></i></a>
                                        <a href="#" className="btn btn-primary btn-sm-square"><i className="fab fa-instagram"></i></a>
                                        <a href="#" className="btn btn-primary btn-sm-square"><i className="fab fa-linkedin-in"></i></a>
                                    </div>
                                </div>
                                <div className="team-content">
                                    <h4>{row.name? row.name: ''}</h4>
                                    <p className="mb-0">{row.status ==1? 'Active': 'Inactive'}</p>
                                </div>
                            </div>
                        </div>
                    )) : <></>}
                    
                </div>
            </div>
        </div>
        {/* <!-- Departments End --> */}


        <Footer/>
        </>
    );
}
